import api from '@/api';

const resource = 'merenda/movimento-diario-merenda';

export default {
  listarMovimentos(anocardapio, identificadorcardapioescola) {
    return api.get( `${resource}`, { params: {anocardapio, identificadorcardapioescola} });
  },
  inserirMovimento(data) {
    return api.post( `${resource}`, data);
  },
  editarMovimento( data ) {
    return api.put( `${resource}/${data.identificadormovimentodiariomerenda}`, data);
  },
  deletarMovimento( identificadormovimentodiariomerenda ) {
    return api.delete(`${resource}/${identificadormovimentodiariomerenda}`);
  },
};
